module.exports = __webpack_public_path__ + "media/images/games/35reveal/face-98b4910b98b8400bfc48b635c85899d4.png";